<app-wrapper-cabinet>
  <app-skip-link-cabinet [target]="main" />

  <app-header-cabinet
    [shouldShowCompanyLogo]="shouldShowCompanyLogo()"
    [currentCompany]="currentCompany()"
    [licenseStatus]="licenseStatus()"
    [pluginConnected]="pluginConnected()"
    [navOpen]="isSidebarOpen"
    [navControls]="sidenav.railId"
    (toggleMobileSidebar)="onToggleSidebar()"
    (badgeClick)="badgeClick.emit()">
    <ng-container ngProjectAs="[headerSearch]"><ng-content select="[headerSearch]"></ng-content></ng-container>
    <ng-container ngProjectAs="[headerStatus]"><ng-content select="[headerStatus]"></ng-content></ng-container>
    <ng-content select="[headerActions]"></ng-content>
  </app-header-cabinet>

  <ng-content select="[shellBanner]"></ng-content>

  <app-wrapper-content-cabinet>
    <app-sidenav-cabinet
      #sidenav
      [isCollapsed]="isSidebarCollapsed"
      [isOpen]="isSidebarOpen"
      (toggleSidebar)="onToggleSidebar()"
      (closeSidebar)="closeSidebar()">
      <app-nav-cabinet [sections]="sections()" [collapsed]="sidenav.collapsed()" (itemAction)="navAction.emit($event)" (childClose)="navChildClose.emit($event)" />
      <app-nav-cabinet railPinned [sections]="pinnedSections()" [collapsed]="sidenav.collapsed()" (itemAction)="navAction.emit($event)" />
    </app-sidenav-cabinet>

    <div class="shell-main">
      <app-content-cabinet #main>
        <router-outlet></router-outlet>
      </app-content-cabinet>
      <ng-content select="[contentOverlay]"></ng-content>
    </div>
  </app-wrapper-content-cabinet>

  <app-footer-cabinet [aboutUrl]="aboutUrl()" [eulaUrl]="eulaUrl()" [privacyUrl]="privacyUrl()"></app-footer-cabinet>

  <app-route-announcer-cabinet [target]="main" [fallbackTitle]="fallbackTitle" />
</app-wrapper-cabinet>
